import React from 'react'
import { useSession } from '@slerp/accounts'
import { ASSET_HOST } from '@slerp/client'
import ExportFilters from './ExportFilters'

const FranchiseFilters = () => {
  const { merchant } = useSession()

  return (
    <ExportFilters
      datePickerLabel='Order'
      url={`https://${merchant?.slug}.${ASSET_HOST}/controls/orders/franchise`}
    />
  )
}

export default FranchiseFilters
